"use client";

import { motion, useInView, useReducedMotion } from "framer-motion";
import type { LucideIcon } from "lucide-react";
import { useRef } from "react";
import { cn } from "@/lib/utils";

interface MotionIconProps {
  icon: LucideIcon;
  size?: number;
  className?: string;
  pulseOnView?: boolean;
  hoverScale?: number;
}

export function MotionIcon({
  icon: Icon,
  size = 24,
  className,
  pulseOnView = false,
  hoverScale = 1.1,
}: MotionIconProps) {
  const reduced = useReducedMotion();
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.6 });

  return (
    <motion.span
      ref={ref}
      className={cn("inline-flex", className)}
      initial={pulseOnView && !reduced ? { scale: 0.85, opacity: 0.6 } : false}
      animate={
        pulseOnView && isInView && !reduced
          ? { scale: 1, opacity: 1 }
          : undefined
      }
      whileHover={reduced ? undefined : { scale: hoverScale, rotate: -4 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
    >
      <Icon size={size} aria-hidden />
    </motion.span>
  );
}
